import { CategoryModal } from "../../../OrganizationQuestionnaire/components/Categories/components/CategoryGrid";
import * as React from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormSelect, NumericFormInput } from "../../../../components/Forms";
import {
  getLabel,
  renderSubTypeOfTransportOptions,
  renderSubTypeTwoOptions,
  renderTypeOfTransportOptions,
  transportTypesWithRequiredSubtypeTwo
} from "../../../OrganizationQuestionnaire/components/Categories/components/Category/transportationAndDistributionHelpers";
import { nonNumericSymbols, VALIDATION_PATTERNS } from "../../../../utils";

function ModalWrapper({ modalData, attributesOrder, isOpen, onClose, onSubmit, getEmptyRow, transportTypes }) {
  const { fieldArrayName, editData } = modalData;
  const { t } = useTranslation("translation", {
    keyPrefix: "multimodalTransportation.modelDetails.gridColumns"
  });
  const { t: globalTranslation } = useTranslation("translation");

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    resetField
  } = useForm({
    defaultValues: {
      [fieldArrayName]: [editData ? editData : getEmptyRow()]
    }
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: fieldArrayName
  });

  const watchFieldArray = watch(fieldArrayName);

  const mapRow = (row, index) => {
    const gridItems = [];
    const typeOfTransportSelector = register(`${fieldArrayName}.${index}.typeOfTransport`, {
      required: globalTranslation("entityRequired", { entityName: t("typeOfTransport") })
    });
    const sybtypeOfTransportSelector = register(`${fieldArrayName}.${index}.subtypeOfTransport`, {
      required: globalTranslation("entityRequired", { entityName: t("subtypeOfTransport") })
    });

    gridItems.push(
      <FormSelect
        errors={errors}
        {...typeOfTransportSelector}
        onChange={(e) => {
          typeOfTransportSelector.onChange(e);
          resetField(`${fieldArrayName}.${index}.subtypeOfTransport`, { defaultValue: "" });
          resetField(`${fieldArrayName}.${index}.subtypeTwo`, { defaultValue: "" });
        }}
        placeholder=" "
        title={watchFieldArray[index].typeOfTransport !== "" ?
          getLabel(
            "typeOfTransport",
            watchFieldArray[index].typeOfTransport,
            transportTypes?.find(el => el.code === watchFieldArray[index].typeOfTransport)?.name ?? ""
          ) : ""
        }
      >
        {renderTypeOfTransportOptions(transportTypes)}
      </FormSelect>
    );

    gridItems.push(
      <FormSelect
        errors={errors}
        {...sybtypeOfTransportSelector}
        onChange={(e) => {
          sybtypeOfTransportSelector.onChange(e);
          resetField(`${fieldArrayName}.${index}.subtypeTwo`, { defaultValue: "" });
        }}
        placeholder=" "
        title={watchFieldArray[index].subtypeOfTransport !== "" ?
          getLabel(
            "subtypeOfTransport",
            watchFieldArray[index].subtypeOfTransport,
            transportTypes?.find(type => type.code === watchFieldArray[index].typeOfTransport)?.subtypes?.find
            (subtype => subtype.code === watchFieldArray[index].subtypeOfTransport)?.name ?? ""
          ) : ""
        }
      >
        {renderSubTypeOfTransportOptions(transportTypes, watchFieldArray[index].typeOfTransport)}
      </FormSelect>
    );

    gridItems.push(
      <FormSelect
        errors={errors}
        {...register(`${fieldArrayName}.${index}.subtypeTwo`, {
          required: transportTypesWithRequiredSubtypeTwo.includes(watchFieldArray[index].typeOfTransport) ?
            globalTranslation("entityRequired", { entityName: t("subtypeTwo") }) : false
        })}
        placeholder=" "
        title={watchFieldArray[index].subtypeTwo !== "" ?
          getLabel(
            "subtypeTwo",
            watchFieldArray[index].subtypeTwo,
            transportTypes?.find(type => type.code === watchFieldArray[index].typeOfTransport)?.subtypes?.find
            (subtype => subtype.code === watchFieldArray[index].subtypeOfTransport)?.subtypeTwos?.find
            (subtype2 => subtype2.code === watchFieldArray[index].subtypeTwo)?.name ?? ""
          ) : ""
        }
      >
        {renderSubTypeTwoOptions(transportTypes, watchFieldArray[index].typeOfTransport, watchFieldArray[index].subtypeOfTransport)}
      </FormSelect>
    );

    gridItems.push(
      <NumericFormInput
        errors={errors}
        type="number"
        {...register(`${fieldArrayName}.${index}.distance`, {
          required: globalTranslation("entityRequired", { entityName: t("distance") }),
          pattern: VALIDATION_PATTERNS.POSITIVE_NUMBER
        })}
        onKeyDown={(e) => nonNumericSymbols.includes(e.key) && e.preventDefault()}
      />
    );

    return gridItems;
  };

  return (
    <CategoryModal
      modalData={modalData}
      formData={{ handleSubmit, fields, append, remove }}
      attributesOrder={attributesOrder}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      getEmptyRow={getEmptyRow}
      mapRow={mapRow}
    />
  );
}

export default ModalWrapper;